import { useEffect, useState, ReactNode } from 'react';
import { Modal } from "react-bootstrap";

interface IDialogProps {
    visible?: boolean,
    children: ReactNode
}
function Dialog(props:IDialogProps) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (typeof props.visible !== 'undefined') setVisible(props.visible);
    }, [props]);

    return (
        <Modal show={visible} {...props}>
            {props.children}
        </Modal>
    );
}

export default Dialog;
